import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useMutation } from '@tanstack/react-query';
import { ICreateDealDirectoryTreePostData, IFlatDirectory } from '../types';

interface ICreateDealDirectoryParams {
    postData: ICreateDealDirectoryTreePostData;
    dealId: number;
}

const createDealDirectoryTree = async ({ postData, dealId }: ICreateDealDirectoryParams): Promise<IFlatDirectory[]> => {
    try {
        const response = await axiosInstance.post(`${API_ENDPOINTS.DEAL_DIRECTORY.TREE(dealId)}`, postData);
        return response.data;
    } catch (error: any) {
        if (error.response?.status !== 500) {
            throw new Error(error.response.data);
        }
        throw new Error('An unexpected error occurred. Please try again.');
    }
};

export const useCreateDealDirectoryTree = () => useMutation({
    mutationFn: createDealDirectoryTree,
});

export default useCreateDealDirectoryTree;
